var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineScissor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6206C241-E2BC-44D6-8FAB-7A6C1CE15C61") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video,-Audio,-Image",
    transform: "translate(-684.000000, -380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scissor",
    transform: "translate(684.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,22.75 C3.57000017,22.75 1.25,20.4299998 1.25,15 L1.25,9 C1.25,3.57000017 3.57000017,1.25 9,1.25 L15,1.25 C20.4299998,1.25 22.75,3.57000017 22.75,9 L22.75,15 C22.75,20.4299998 20.4299998,22.75 15,22.75 L9,22.75 Z M2.75,9 L2.75,15 C2.75,19.6100001 4.38999987,21.25 9,21.25 L15,21.25 C19.6100001,21.25 21.25,19.6100001 21.25,15 L21.25,9 C21.25,4.38999987 19.6100001,2.75 15,2.75 L9,2.75 C4.38999987,2.75 2.75,4.38999987 2.75,9 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75,8.97979736 C5.75,7.50979733 6.94998288,6.29980469 8.41998291,6.29980469 C9.88998294,6.29980469 11.0900269,7.49979734 11.0900269,8.97979736 C11.0900269,10.4597974 9.89998293,11.6497955 8.41998291,11.6497955 C6.94998288,11.6497955 5.75,10.4497974 5.75,8.97979736 Z M7.25,8.97979736 C7.25,9.62979734 7.77998292,10.1497955 8.41998291,10.1497955 C9.0599829,10.1497955 9.59002686,9.61979735 9.59002686,8.97979736 C9.59002686,8.33979738 9.06998289,7.79980469 8.41998291,7.79980469 C7.76998293,7.79980469 7.25,8.32979739 7.25,8.97979736 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75,15.0200958 C5.75,13.5400958 6.94998288,12.3500977 8.41998291,12.3500977 C9.88998294,12.3500977 11.0900269,13.5500958 11.0900269,15.0200958 C11.0900269,16.4900959 9.89998293,17.7000885 8.41998291,17.7000885 C6.94998288,17.7000885 5.75,16.5000958 5.75,15.0200958 Z M7.25,15.0200958 C7.25,15.6600958 7.77998292,16.2000885 8.41998291,16.2000885 C9.0599829,16.2000885 9.59002686,15.6700958 9.59002686,15.0200958 C9.59002686,14.3700958 9.06998289,13.8500977 8.41998291,13.8500977 C7.76998293,13.8500977 7.25,14.3800958 7.25,15.0200958 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5604203,14.6399755 C9.3104203,14.3099755 9.38044471,13.8399725 9.71044472,13.5899725 L17.0504107,8.09998208 C17.3804108,7.84998208 17.8503981,7.91997597 18.1003981,8.24997598 C18.3503981,8.57997599 18.2804347,9.04997909 17.9504347,9.29997909 L10.6104081,14.7899694 C10.4704081,14.8899694 10.3203959,14.9399786 10.1603959,14.9399786 C9.93039586,14.9399786 9.71042031,14.8399756 9.5604203,14.6399755 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0504107,15.8798285 L9.71044472,10.3898228 C9.38044471,10.1398228 9.3104203,9.66981974 9.5604203,9.33981973 C9.8104203,9.00981972 10.2804081,8.93982583 10.6104081,9.18982583 L17.9504347,14.6798162 C18.2804347,14.9298162 18.3503981,15.3998193 18.1003981,15.7298193 C17.9503981,15.9298193 17.7304225,16.0298223 17.5004225,16.0298223 C17.3404225,16.0298223 17.1904107,15.9798285 17.0504107,15.8798285 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineScissor);
export default __webpack_public_path__ + "static/media/vuesax-outline-scissor.f2aa6bbdf15effa8cbe94d6cee5b541f.svg";
export { ForwardRef as ReactComponent };